import { render, staticRenderFns } from "./about_us.vue?vue&type=template&id=4b4dad36&scoped=true"
import script from "./about_us.vue?vue&type=script&lang=js"
export * from "./about_us.vue?vue&type=script&lang=js"
import style0 from "./about_us.vue?vue&type=style&index=0&id=4b4dad36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4dad36",
  null
  
)

export default component.exports